import React, {Component} from 'react'
import PropTypes from "prop-types";
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import SvGraphics from "../../assets/SvGraphics";

class SelfCurrentPainMedications extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            currentPain_medications: this.props.currentPain_medications,
            medicationsList: this.props.medicationsList,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    componentDidMount() {
        this.setState({Currently_taking: this.state.entry.Currently_taking==="Yes"})

    }

    handleAllergicsMultiChange(event){
        this.props.onClickPatientAllergics(event)
    }
    handleMedicationChange(option,index) {
        this.props.onClickAddDeleteMedications(index , option, "Med_ID","CP")
    }

    render() {
        let {t} = this.props

        let {entry}= this.state.entry
        let currentPain_medications =this.props.currentPain_medications
        let medicationsList =this.props.medicationsList


        let medicationsListArr=[]
        for(let i=0;i<medicationsList.length;i++){
            if( !medicationsList[i].BloodThinner || medicationsList[i].Medication_name==="Other"){
                medicationsListArr.push({value:medicationsList[i].Med_ID, label:medicationsList[i].Medication_name})
            }
        }

        let medicationsArr = currentPain_medications.map( (item, index) =>
            <div>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.Med_ID')}</label>
                        <PatientSelectComponent
                            className={'multipleSelectBox'}
                            placeholder={t('patient_self_boarding.med_choose')}
                            options={medicationsListArr}
                            value={item.MedObj}
                            onChange={this.handleMedicationChange.bind(this,index)}
                        />
                    </div>

                    <div className={'inputSlots'} style={{display: item.Medication_name==="Other"?'block':'none'}}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.enter_med')}</label>
                        <input className={'inputBoxStyle'} type="text" name="Med_ID" id="Med_ID"
                               value={item.OtherMed}
                               maxLength={25}
                               onChange={event => this.props.onClickAddDeleteMedications(index, event.target.value, "OtherMed","CP")}/>
                    </div>
                    <div className={'inputSlots-delete-icon'}>
                        <SvGraphics className={"delete-icon-medication"}
                                    onClick={() => this.props.addDeleteMedication("deleteCP",index)} svgname={'delete-icon'}/>
                    </div>
                </div>
{/*                <div className={'patientsFormRow'}>
                        <div className={'inputSlots'}>
                            <label className={'infoLabel'}>{t('patient_self_boarding.Dose')}:</label>
                            <input className={'inputBoxStyle'} type="number"  name="Dosage_mg_day" id="Dosage_mg_day" value={item.Dosage_mg_day}
                                   maxLength={5} min={0} max={99999}
                                   onChange={event => this.props.onClickAddDeleteMedications(index , event.target.value, "Dosage_mg_day","CP")}/>
                        </div>

                        <div className={'inputSlots'}>
                            <label className={'infoLabel-Empty'}/>
                                <select className={'selectBox'} id="Dosage_unit" name="Dosage_unit" value={item.Dosage_unit}
                                        onChange={event => this.props.onClickAddDeleteMedications(index , event.target.value, "Dosage_unit","CP")}>
                                    <option value="mg">mg</option>
                                    <option value="mcg">mcg</option>
                                    <option value="gr">gr</option>
                                    <option value="ml">ml</option>
                                </select>

                        </div>
                </div>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsHalfBlock'}>
                            <label className={'infoLabel'}>{t('patient_self_boarding.Treatment_duration')}</label>
                        <div className={'medication-duration-boxes'}>
                        <div className={item.Duration==="-1"?'medication-duration-box-selected':'medication-duration-box'}
                                 onClick={event => this.props.onClickAddDeleteMedications(index , "-1" ,"Duration","CP")}>
                                {t('patient_self_boarding.less_than_month')}
                            </div>
                            <div className={item.Duration==="1-6"?'medication-duration-box-selected':'medication-duration-box'}
                                 onClick={event => this.props.onClickAddDeleteMedications(index , "1-6" ,"Duration","CP")}
                            >{t('patient_self_boarding.1_6M')}</div>
                            <div className={item.Duration==="6-12"?'medication-duration-box-selected':'medication-duration-box'}
                                 onClick={event => this.props.onClickAddDeleteMedications(index , "6-12" ,"Duration","CP")}
                            >{t('patient_self_boarding.6_12M')}</div>
                            <div className={item.Duration==="12+"?'medication-duration-box-selected':'medication-duration-box'}
                                 onClick={event => this.props.onClickAddDeleteMedications(index , "12+" ,"Duration","CP")}
                            >{t('patient_self_boarding.1+Y')}</div>
                        </div>
                    </div>
                </div>
                <div className={'patientsFormRow'}>
                    <div className={'line-space'}/>
                </div>*/}
            </div>

        )

        return (
            <div className={'patientsFormBoxes'}>

                {medicationsArr}
                <div className={'patientsFormRow'}>
                    <label className={'add-medication-button'} onClick={() => this.props.addDeleteMedication("addCP",currentPain_medications.length)}>
                        {t('patient_self_boarding.add_medication')}</label>
                </div>
            </div>

        )
    }
}

SelfCurrentPainMedications.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default SelfCurrentPainMedications;
